import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

const FotoVideographieCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="py-32 relative overflow-hidden bg-zinc-950">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      
      {/* Content */}
      <div className="container mx-auto px-6 text-center relative z-10">
        <div className={`max-w-4xl mx-auto transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <span className="text-[#d1bc8a] text-sm uppercase tracking-[0.3em] font-light mb-6 block">
            Bereit zu starten?
          </span>
          
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-8">
            Lassen Sie uns
            <br />
            <span className="text-[#d1bc8a]">zusammenarbeiten</span>
          </h2>
          
          <p className="text-xl text-white/70 mb-12 max-w-2xl mx-auto font-light leading-relaxed">
            Verwandeln Sie Ihre Vision in beeindruckende Bilder und Videos. Kontaktieren Sie uns für ein unverbindliches Angebot
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Button
              onClick={() => navigate('/kontakt')}
              className="w-full sm:w-auto px-8 py-4 bg-[#d1bc8a] text-black rounded-full hover:bg-[#c4af7d] transition-all duration-300 font-semibold text-lg whitespace-nowrap cursor-pointer"
            >
              Kostenlose Beratung
            </Button>
            <Button
              onClick={() => window.open('tel:017645725863', '_self')}
              variant="outline"
              className="w-full sm:w-auto px-8 py-4 border-2 border-white text-white rounded-full hover:bg-white hover:text-black transition-all duration-300 font-semibold text-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Jetzt anrufen
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FotoVideographieCTA;